$(function () {
    let params = location.search.substring(1).split('&');
    $.each(params, function (index, val) {
        let key = val.split('=');
        if (key[0] == 'new_flg' || key[0] == 'sale_flg' || key[0] == 'recommend_flg' || key[0] == 'b_grade_flg' || key[0] == 'on_sale_flg') {
            if (key[1] == 1) {
                let i = key[0].slice(0, -4);
                let ele = $('#' + i);
                ele.addClass('checked');
                ele.trigger("click");
            } else if (key[0] == "on_sale_flg" && key[1] == 0) {
                let i = key[0].slice(0, -4);
                let ele = $('#' + i);
                ele.addClass('checked');
                ele.trigger("click");
            }
        }
    });

    $('input[type=checkbox]').click(function () {
        $(this).toggleClass('checked');

        //販売中の商品のみ表示のチェックの場合、絞り込み検索機能を強制発火させる
        if ($(this).attr('name') === 'on_sale') {
            $('#refinement-btn').trigger("click");
        }
    });

    $('#refinement-btn').click(function () {
        let route = '';
        let url = location.search;
        url = url.substring(1).split('&');

        $.each(url, function (index, val) {
            if (val.indexOf('category_code') !== -1 || val.indexOf('keyword') !== -1 || val.indexOf('related_product') !== -1) {
                route = '?' + val;
            }
        });

        let params_check = {};
        params_check['new_flg'] = $('[name="new"]').hasClass('checked') ? 1 : 0;
        params_check['sale_flg'] = $('[name="sale"]').hasClass('checked') ? 1 : 0;
        params_check['recommend_flg'] = $('[name="recommend"]').hasClass('checked') ? 1 : 0;
        params_check['b_grade_flg'] = $('[name="b_grade"]').hasClass('checked') ? 1 : 0;
        params_check['on_sale_flg'] = $('[name="on_sale"]').hasClass('checked') ? 0 : '';
        params_check['min_price'] = $('[name=min_price]').val();
        params_check['max_price'] = $('[name=max_price]').val();

        $.each(params_check, function (index, val) {
            if (val) {
                if (route === '') {
                    route = '?' + index + '=' + val;

                } else if (route.indexOf('?') !== 1) {
                    route = route + '&' + index + '=' + val;
                }
            } else if (index == "on_sale_flg" && val === 0) {
                if (route === '') {
                    route = '?' + index + '=' + val;

                } else if (route.indexOf('?') !== 1) {
                    route = route + '&' + index + '=' + val;
                }
            }
        });

        window.location.href = '/item/list' + route;
    });
});